import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {pullRequestsOverviewRoute} from '../../../routes/overview-route'
import type {SinceSelector, SinceSource} from '../../../routes/route-payload-types'
import {Activity} from '../Activity'
import {CollapsiblePanel} from '../CollapsiblePanel'
import {ActivitySelector} from './ActivitySelector'
import {useState, useCallback} from 'react'

export function ActivitySection() {
  const {data: overviewData} = useRouteQuery(pullRequestsOverviewRoute, 'mainQuery')
  const {sinceSelectors, lastActivityTimestamp} = overviewData
  const [userSelection, setUserSelection] = useState<SinceSource | null>(null)
  const serverSelected = sinceSelectors.find(s => s.selected) ?? sinceSelectors[0] ?? null
  const effectiveSelection =
    (userSelection !== null ? sinceSelectors.find(s => s.source === userSelection) : null) ?? serverSelected
  const handleSelect = useCallback((s: SinceSelector) => setUserSelection(s.source), [])

  // mostly a typescript guard — the route should always return a selector since we always have at least the "since created" selector
  if (!effectiveSelection || sinceSelectors.length === 0) return null

  return (
    <CollapsiblePanel
      heading="Activity"
      headerAction={
        <ActivitySelector selectors={sinceSelectors} selection={effectiveSelection} onSelect={handleSelect} />
      }
    >
      <Activity sinceTimestamp={effectiveSelection.timestamp} lastActivityTimestamp={lastActivityTimestamp} />
    </CollapsiblePanel>
  )
}
